import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'

const Terapia = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const voltar = useCallback(() => {
    setTela('lista')
    setDados(undefined)
  }, [])

  const exclui = useCallback((dadosAtendimento) => {
    metodoPrograma('exclui', { idTerapia: dadosAtendimento[0] }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
  }, [tela, voltar])

  return (
    <Programa codigo="CtrlTerapia" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              codigo="CtrlTerapia"
              action="lista"
              rows={10}
              habSearch
              head={['Nome', 'Inclusão', 'Exclusao', 'Valor']}
              line={(item) => [item[1], item[4], item[5], item[3]]}
              collumnsDateHour={[1, 2]}
              collumnsCurrency={[3]}
              parametros={{ teste: true }}
              onRowSelect={handleClick}
              onDelete={{ index: 5, action: exclui }}
              refresh={refresh}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar, setTela }} />
      )}
    </Programa>
  )
}

export default Terapia
